import React from 'react';

export const JobCard = ({ job, onClick }) => {
  return (
    <div className="job-row" onClick={() => onClick(job)}>
      <div className="job-left">
        <div className="job-top">
          <div className="job-title">{job.title}</div>
          {job.available && <span className="job-badge">Open</span>}
        </div>
        <div className="job-type">{job.type}</div>
        <p className="job-desc">{job.description}</p>
        <div className="job-stack">
          {job.stack.map(t => <span key={t} className="job-pill">{t}</span>)}
        </div>
      </div>
      <div className="job-right">
        <div className="job-earn">
          <div className="job-earn-label">You keep</div>
          <div className="job-earn-val">{job.earn}</div>
        </div>
        <span className="job-apply-btn">View Brief →</span>
      </div>
    </div>
  );
};